module.exports = {
	"history": {
		"title": "PROUDLY ELCON MEGARAD SINCE 35 YEARS",
		"label": "HISTORY",
		"p1": "Elcon Megarad is the Italian leader that designs, produces, tests and markets power cable accessories and components for low, medium and high voltage.",
		"p2": "Since 1981 we develop and homologate specific proprietary solutions, with certified quality, compliant with the strictest international technical specifications. Thanks to our passion for research and technological innovation we operate and are internationally recognized as the certified reference point for all players, operators and experts in this sector.",
		"advCaption": "90“ ad"
	},
	"quote": {
		"text": "Our know-how and our energy are daily applied to the network of our customers. Elcon Megarad: connecting the energy since 35 years"
	},
	"map": {
		"title": "IT IS HERE THAT WE PRODUCE RESEARCH AND INNOVATION",
		"label": "FIND US",
		"p1": "We are <strong>the only ones</strong> in Italy to produce and assemble our products entirely “in house“.",
		"avTitle": "Arcella",
		"avCity": "Avellino",
		"avDivision": "Cable Accessories Division",
		"ceTitle": "Mignano Monte Lungo",
		"ceCity": "Caserta",
		"ceDivision": "Chemical Division"
	},
	"newProducts": {
		"title": "THE PRODUCTS WHICH WILL MARK THE YEARS AHEAD",
		"label": "NEW PRODUCTS",
		"p1": "Elconext, outer cone separable connector; Elcon VTS, our range of premolded pre-expanded cold-shrinkable termination; Elcold GLS 89RR, ALL-IN-ONE ultra compact joint. Our contribution to the <strong>progress</strong> of energy.",
		"link": "Tech Sheet",
		"slide1": "COLD SHRINKABLE JOINTS",
		"slide2": "COLD SHRINKABLE TERMINATIONS",
		"slide3": "ELCONEXT"
	},
	"allProducts": {
		"title": "THE COMPONENTS AND ACCESSORIES WHICH MADE US GREAT",
		"label": "CATALOGUE",
		"p1": "We produce and serve the market with the most <strong>reliable</strong> technologies, Internationally Certified!",
		"catGen": "General",
		"catLowVolt": "Low voltage accessories",
		"catMidVolt": "Medium voltage accessories",
		"catHighVolt": "High voltage accessories",
		"catPrinted": "Tubing and printed parts",
		"catTape": "Mastics, Tapes and Resins",
		"subcatLowVolt1": "Special Purposes Low Voltage Joints and Terminations",
		"subcatLowVolt2": "Low Voltage Joints and Terminations",
		"subcatMidVolt1": "Medium Voltage power cable Joints",
		"subcatMidVolt2": "Medium Voltage power cable Terminations",
		"subcatMidVolt3": "Joints and Terminations for Renewable Energy and Wind Farms",
		"subcatMidVolt4": "Single core cable connections",
		"subcatHighVolt1": "Heat shrinkable Joints for 52 kV Cables",
		"subcatHighVolt2": "Heat shrinkable Terminations for 52 kV Cable",
		"subcatPrinted1": "Medium Voltage Std heat shrink tubing",
		"subcatPrinted2": "Low voltage thin wall heat shrink tubing",
		"subcatPrinted3": "Medium voltage special heat shrink tubing",
		"subcatPrinted4": "Special purposes heat shrink tubing",
		"subcatPrinted5": "Heat shrink tubing for automotive applications",
		"subcatPrinted6": "Multi wall MV special heat shrink tubing",
		"subcatPrinted7": "Heat shrink moulded components",
		"subcatTape1": "Mastics",
		"subcatTape2": "Tapes",
		"subcatTape3": "Resins"
	},
	"places": {
		"title": "A STORY WE ARE BEING WRITING DAILY IN MORE THAN 50 COUNTRIES",
		"label": "LATEST INSTALLATIONS",
		"p1": "Not only high-performance and certified Products, but also excellent customized pre and after sales service.",
		"p2": "That’s why <strong>customers from all around the world</strong> blindly trust us since 35 years.",
		"dubai": "dubai",
		"hannover": "hannover"
	},
	"certs": {
		"title": "CERTIFICATIONS",
		"label": "CERTIFICATIONS",
		"link": "List"
	},
	"footer": {
		"label": "Go to homepage",
		"link": "Go to homepage"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./web/locales/en.json
 ** module id = 260
 ** module chunks = 0
 **/